export default __webpack_public_path__ + "media/titles/title_5_locale_nl-794983da.png";